// ----------------------------------------------------------------------------
// -------------------------------------------------------------------- Imports
// ----------------------------------------------------------------------------
// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ Libraries
import React from 'react'
import compose from 'recompose/compose'
import { connect } from 'react-redux'

import classnames from 'classnames'

// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ Components
import Row from 'antd/lib/row'
import 'antd/lib/row/style/css'

import Col from 'antd/lib/col'
import 'antd/lib/col/style/css'

import { Spring, animated } from 'react-spring'

// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ Locals
import Link from '../../link'
import '../../link/style.less'

import Cross from '../../svg/cross'

import { updateHeaderState } from '../../../state/actions'

// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ Abstractions
// const { Fragment } = React

// ----------------------------------------------------------------------------
// ------------------------------------------------------------------ Component
// ----------------------------------------------------------------------------
const Glider = React.memo(
  ({ headerState: { isActive }, updateHeaderState, children }) => (
    <Spring
      native
      reset
      reverse={!isActive}
      from={{ width: '0vw' }}
      to={{
        width: isActive === true ? '99vw' : '0vw',
      }}
    >
      {(props) => (
        <animated.div
          className={classnames('glider', {
            active: isActive,
            passive: !isActive,
          })}
          style={{
            width: props.width,
            maxWidth: props.width,
          }}
        >
          <Row>
            <Col xs={20} sm={20} md={20} lg={22} xl={22} xxl={22}>
              {children}
            </Col>
            <Col xs={4} sm={4} md={4} lg={2} xl={2} xxl={2}>
              <Link
                to="#"
                className="action"
                onClick={(e) => {
                  e.preventDefault()
                  updateHeaderState({
                    isActive: !isActive,
                  })
                }}
              >
                <Cross />
                <span>Close</span>
              </Link>
            </Col>
          </Row>
        </animated.div>
      )}
    </Spring>
  )
)

// ----------------------------------------------------------------------------
// ---------------------------------------------------------------------- State
// ----------------------------------------------------------------------------
const withState = connect(
  (state) => ({
    headerState: state.headerState,
  }),
  (dispatch) => ({
    updateHeaderState(payload) {
      dispatch(updateHeaderState(payload))
    },
  })
)

// ----------------------------------------------------------------------------
// -------------------------------------------------------------------- Compose
// ----------------------------------------------------------------------------
/** Compose ala FP style */
const ComposedGlider = compose(
  withState // Add state
)(Glider)

// ----------------------------------------------------------------------------
// -------------------------------------------------------------------- Exports
// ----------------------------------------------------------------------------
export default ComposedGlider
